import { Component, ViewChild } from '@angular/core';
import { Platform, Nav } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Auth } from '../providers/auth';
import { LoadingController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Events } from 'ionic-angular'; 


/* --- PAGES --- */
import { AboutPage } from '../pages/about/about';
import { CollectiblesPage } from '../pages/collectibles/collectibles';
import { HomePage } from '../pages/home/home';
import { SettingsPage } from '../pages/settings/settings';
import { GamemodesPage } from '../pages/gamemodes/gamemodes';
import { VersusAIPage } from '../pages/versusai/versusai';
import { VersusPVPAsyncPage } from '../pages/versuspvpasync/versuspvpasync';
import { VersusPVPsyncPage } from '../pages/versuspvpsync/versuspvpsync';

import { SurveyPage } from '../pages/survey/survey';
import { LoginPage } from '../pages/login/login';
import { HowToPage } from '../pages/howto/howto';
import { RankingsPage } from '../pages/rankings/rankings';
import { PlayPage } from '../pages/play/play';

import { ProfilePage } from '../pages/profile/profile';

import { Functions } from '../providers/functions';
import { UserdataModel } from '../providers/userdata-model';
import { GameModel } from '../providers/game-model';
import { DataExchanger } from '../providers/data-exchanger';
import { IntroPage } from '../pages/intro/intro';
import { URLSearchParams, JsonpModule } from '@angular/http';

@Component({
  templateUrl: 'app.html',
  providers: [],
  host: { '(document:mousemove)': 'handleTimer($event)',
  '(document:keypress)': 'handleTimer($event)', 
  '(document:load)': 'handleTimer($event)', 
  '(document:mousedown)': 'handleTimer($event)', 
  '(document:touchstart)': 'handleTimer($event)', 
  '(document:click)': 'handleTimer($event)', 
  '(document:scroll)': 'handleTimer($event)' }
})

export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage:any;
  loader:any;

  pages: Array<{title: string, component: any, icon: string, functionORpage: string}>;
  activePage: any;
  defaultLanguage:string ='en'; // it o en

  submenus: Array<{title: string, component: any, icon: string, functionORpage: string}>;
  shownGroup = null;
  imTheLeader: boolean = false;
  socket;
  vsPlayerName: string; //Show the vs player name
  vsPlayerGuid: string; //Show the vs player guid
  localPlayerName: string; //Show the local player name
  localPlayerGuid: string; //Show the loca player guid
  pvpLoadingCheck: boolean = true; //Show loading or vs image
  room: string = ""; //Room name
  loadingText: string; //Text for loading pop
  pvp_sync_modal_title: string; //Text for loading modal
  pvp_sync_modal_title_finded: string; //Text for loading modal finded
  pvp_sync_modal_disconnect: string; //Text for loading modal

  constructor(platform: Platform, public dataExchanger: DataExchanger, public userdataModel: UserdataModel, public playModel: GameModel, public events: Events, statusBar: StatusBar, splashScreen: SplashScreen, public auth: Auth, public loadingCtrl: LoadingController, public functions: Functions, public translate: TranslateService)
   {
    let params = new URLSearchParams(window.location.search.slice(1));
    if (params.get('indexPrvUsrLog')!=null) { 
      this.auth.barbicanEventActive=true;
      this.auth.startOverSystemActive=true;
      this.auth.indexStartOverUserCurrentlyLogged=parseInt(params.get('indexPrvUsrLog'));
    }else{
      //this.auth.indexStartOverUserCurrentlyLogged=this.auth.usersToSwitchDuringStartOver.length-1;
    }

    if (params.get('pc')!=null) { 
      this.auth.barbicanIdPcConnected=parseInt(params.get('pc'));
    }else{
      this.auth.barbicanIdPcConnected=0;
    }

    statusBar.hide();
    statusBar.overlaysWebView(false);
    this.functions.language=this.defaultLanguage;
    this.functions.setLanguage();
    translate.setDefaultLang(this.functions.language);
    translate.use(this.functions.language);
    
    platform.ready().then(() => {
      // As the app is ready hide the splash screen
      splashScreen.hide();

      /* The menu html is in app.html */
      this.pages = [ //ribbon heart
        { title: 'Play', component: HomePage, icon: 'paw', functionORpage:'page' },
        { title: 'Gamemodes', component: GamemodesPage, icon: 'flask', functionORpage:'page' },
        { title: 'Rankings', component: RankingsPage, icon: 'ribbon', functionORpage:'page' },
        { title: 'Settings', component: SettingsPage, icon: 'settings', functionORpage:'page' },
        { title: 'How to Play', component: HowToPage, icon: 'help', functionORpage:'page' },
        { title: 'Collectibles', component: CollectiblesPage, icon: 'trophy', functionORpage:'page' },
        { title: 'Profile', component: ProfilePage, icon: 'image', functionORpage:'' },
        //{ title: 'Survey', component: SurveyPage, icon: 'create', functionORpage:'' },
        { title: 'About', component: AboutPage, icon: 'contacts', functionORpage:'page' }
        //{ title: 'Logout', component: AboutPage, icon: 'power', functionORpage:'logout' }
      ];

      // Sottomenu of Gamemodes
      this.submenus = [ 
        { title: 'Classics', component: GamemodesPage, icon: 'create', functionORpage:'page' },
        { title: 'Challenge AI', component: VersusAIPage, icon: 'assets/img/rubedo_robot.png', functionORpage:'page' },
        { title: 'Challenge Human', component: VersusPVPAsyncPage, icon: 'people', functionORpage:'page' },
        { title: 'Challenge Human Live', component: VersusPVPsyncPage, icon: 'md-git-compare', functionORpage:'page' }
      ]

      this.loadLangStringMenu();
      this.activePage = this.pages[0];

      this.rootPage=IntroPage;
    });

    // This events is called in functions when the language changes.
    // This way I can change menu language accordingly to the changes calling
    // again loadLangStringMenu which modify menu Title with the new language set in
    // functions setLanguage
    events.subscribe('menu:langChanged', () => {
      this.loadLangStringMenu();
    });
 
    
    //Pairing logic PVP
    this.translate.get('lodingPvPSync').subscribe(res => {
      this.loadingText = res;
    });
    this.translate.get('pvp_sync_modal_title').subscribe(res => { 
      this.pvp_sync_modal_title = res;
    }); 
    this.translate.get('pvp_sync_modal_title_finded').subscribe(res => {
      this.pvp_sync_modal_title_finded = res;
    });
    this.translate.get('pvp_sync_modal_disconnect').subscribe(res => {
      this.pvp_sync_modal_disconnect = res;
    });
 

    //Get Socket
    this.socket = this.functions.getSocket();
    var that = this;

    //Socket listner for gat game data from Leader Player to Slave Player
    this.socket.on('sendDataToSlave', function (leaderData) {
      console.log("@ I'M THE LEADER1?: " + leaderData.role)
      if (leaderData.role == 'slave') {
        that.functions.idBookChosenVersusPVPSync = leaderData.idBookChosenVersusPVPSync
        that.functions.languageBookVersusPVPSync = leaderData.languageBookVersusPVPSync
        that.functions.guidChallengerPvpSync = leaderData.guidChallengerPvpSync
        that.functions.chunkChosenForVersusPVPSync = leaderData.chunkChosenForVersusPVPSync
        //that.functions.timesWasPlayedPVP = that.playModel.getTimesGamePlayedPVPSync(that.userdataModel.getGuidUser(),that.functions.idBookChosenVersusPVPSync,that.functions.chunkChosenForVersusPVPSync);
              
        that.dataExchanger.getTimesChunkWasPlayedPVP(that.userdataModel.getGuidUser(),that.functions.chunkChosenForVersusPVPSync,that.functions.idBookChosenVersusPVPSync).then((data) => {
          that.functions.timesWasPlayedPVP = parseInt(JSON.stringify(data));
        });

        console.log("SLAVE: idBookChosenVersusPVPSync: " + that.functions.idBookChosenVersusPVPSync);
        console.log("SLAVE: languageBookVersusPVPSync: " + that.functions.languageBookVersusPVPSync);
        console.log("SLAVE: guidChallengerPvpSync: " + that.functions.guidChallengerPvpSync);
        console.log("SLAVE: chunkChosenForVersusPVPSync: " + that.functions.chunkChosenForVersusPVPSync);
      }

      that.imTheLeader == false;
    })


    //Socket listner, when players are paired start the game and dismiss loading
    this.socket.on('game start', function (data) {
      //Check for data Leader
      if (data.leader) {
        //that.imTheLeader = true;
        console.log("@  I'M THE LEADER2?: " + data.leader)
        that.functions.setIdBookChosenVersusPVPSync(that.chooseBookVersusSync());
        that.functions.setLanguageBookVersusPVPSync('en');
        that.functions.setGuidChallengerPvpSync(data.guidUser);
        that.getChunkForPVPgame().then((response) => {
          that.functions.setTimesWasPlayedPVP(parseInt(response[0].timesWasPlayed));
          that.functions.setChunkChosenForVersusPVPSync(parseInt(response[0].idChunkInBook));
          console.log("LEADER: idBookChosenVersusPVPSync: " + that.functions.idBookChosenVersusPVPSync);
          console.log("LEADER: languageBookVersusPVPSync: " + that.functions.languageBookVersusPVPSync);
          console.log("LEADER: guidChallengerPvpSync: " + that.functions.guidChallengerPvpSync);
          console.log("LEADER: chunkChosenForVersusPVPSync: " + that.functions.chunkChosenForVersusPVPSync);

          var leaderData = {
            idBookChosenVersusPVPSync: that.functions.idBookChosenVersusPVPSync,
            languageBookVersusPVPSync: that.functions.languageBookVersusPVPSync,
            guidChallengerPvpSync: that.functions.guidChallengerPvpSync,
            chunkChosenForVersusPVPSync: that.functions.chunkChosenForVersusPVPSync,
            role: "slave"
          }

          //Socket call to send Leader Player data to Slave Player
          that.socket.emit('sendDataToSlave', leaderData);
        });


      }

      //Reset all data in the pairing popup
      that.pvpLoadingCheck = false;
      that.room = data.room;
      that.vsPlayerName = data.username;
      that.vsPlayerGuid = "(" + data.guidUser + ")";
      that.functions.setUsernameChallengerPVPSync(data.username);

      //Set interval for popup pairing about 2/3 seconds
      var waitVS = setInterval(function () {
        clearInterval(waitVS); 
        that.functions.setGameModeVersusPVPSync(true); //Set Game mode PVP
        //Reset popup
        document.getElementById("find-pvp-player-pop").style.display = "none";
        that.pvpLoadingCheck = true;
        that.vsPlayerName = "";
        that.vsPlayerGuid = "";
        that.localPlayerName = "";
        that.localPlayerGuid = "";
        document.getElementById('localPlayerName').innerHTML = "";
        //document.getElementById('localPlayerGuid').innerHTML = ""; //Show guid, this is only for developing mode
        that.nav.push(PlayPage, {}); //Go to play page
  
      }
        , 2500);


    });
    
  } 

  handleTimer(event: KeyboardEvent) {
    if (this.auth.startOverSystemActive) {
      this.auth.resetTimer();
    }
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
        this.shownGroup = null;
    } else {
        this.shownGroup = group;
    }
  }

  isGroupShown(group) {
      return this.shownGroup === group;
  }

  loadLangStringMenu(){
    this.translate.get('homeMenu').subscribe(value => { this.pages[0].title = value;});
    this.translate.get('gamemodeMenu').subscribe(value => { this.pages[1].title = value;});
    this.translate.get('rankingsMenu').subscribe(value => { this.pages[2].title = value;});
    this.translate.get('settingsMenu').subscribe(value => { this.pages[3].title = value;});
    this.translate.get('howtoMenu').subscribe(value => { this.pages[4].title = value;});
    this.translate.get('collectiblesMenu').subscribe(value => { this.pages[5].title = value;});
    this.translate.get('profileMenu').subscribe(value => { this.pages[6].title = value;});
    //this.translate.get('surveyMenu').subscribe(value => { this.pages[6].title = value;});
    this.translate.get('aboutMenu').subscribe(value => { this.pages[7].title = value;});
    //this.translate.get('logout').subscribe(value => { this.pages[7].title = value;});

    this.translate.get('classicsMenu').subscribe(value => { this.submenus[0].title = value;});
    this.translate.get('versusAIMenu').subscribe(value => { this.submenus[1].title = value;});
    this.translate.get('pvpMenu').subscribe(value => { this.submenus[2].title = value;});
    this.translate.get('pvpLiveMenu').subscribe(value => { this.submenus[3].title = value;});
  }

  presentLoading() {
    this.translate.get('loading').subscribe(value => { 
      this.loader = this.loadingCtrl.create({
        content: value
      });
      this.loader.present();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    /*if(page.functionORpage=='logout'){
      this.logoutCurrentProfile();
    }else{*/
      this.nav.setRoot(page.component);
      this.activePage = page;
    //}
  }

  checkActive(page){
    return page == this.activePage;
  }

  logoutCurrentProfile(){
    if(this.functions.deviceIsOnline()){
      this.presentLoading();
        this.auth.logout().then((response)=>{
          var responseString:string;
          responseString=response.toString();
          if(responseString.indexOf('LogoutIsOk')!=-1){
            this.loader.dismiss();
            this.nav.setRoot(LoginPage, {});
           }else{
             //this.errorMessage=this.auth.errorMessage;
             this.loader.dismiss();
             return;
          }
        });
    }else{
      //translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
    }
  }


  chooseBookVersusSync() {
    var randomItem = 0;
    var bookPlayableInCurrentLanguage = [];
    var booksPlayableInCurrentMode = this.functions.booksPlayableInVersusPVPSync;

    // PVP live is played only in english for
    for (let i = 0; i < booksPlayableInCurrentMode.length; i++) {
      if (this.userdataModel.getLanguageofBook(booksPlayableInCurrentMode[i]) == 'en') {
        bookPlayableInCurrentLanguage.push(booksPlayableInCurrentMode[i]);
      }
    }

    if (bookPlayableInCurrentLanguage.length == 0) {
      console.log("ERROR: book available for versus not found!");
      return 1;
    }
    randomItem = this.functions.getRandomIntBetween(0, bookPlayableInCurrentLanguage.length - 1);
    return bookPlayableInCurrentLanguage[randomItem];
  }

  getChunkForPVPgame() {
    return new Promise((resolve) => {
      this.dataExchanger.getChunkForPVPgame(this.userdataModel.getGuidUser(), this.functions.getGuidChallengerPvpSync(), this.functions.getIdBookChosenVersusPVPSync()).then((response) => {
        resolve(response);
      });
    });
  }

  //Close pairing popup
  closePvpModal() {
    console.log("@ Remove Player From socket queue");
    //Socket call, for remove player from game queue if not already paired
    this.socket.emit('removePlayerFromQueue');
    //Reset pairing  popup
    document.getElementById("find-pvp-player-pop").style.display = "none";
    this.pvpLoadingCheck = true;
    this.vsPlayerName = "";
    this.vsPlayerGuid = "";
    this.localPlayerName = "";
    this.localPlayerGuid = "";
    document.getElementById('localPlayerName').innerHTML = "";
    //document.getElementById('localPlayerGuid').innerHTML = ""; //Remove guid, this is only for developing mode
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts